<script setup lang="ts">
const {t} = useI18n()
const info = {
  frontEnd: {
    title: t('services.offer.frontEnd.title'),
    description: t('services.offer.frontEnd.description'),
    imagePath: 'services-what-we-offer-md.svg',
  },
  mobile: {
    title: t('services.offer.mobile.title'),
    description: t('services.offer.mobile.description'),
    imagePath: 'services-what-we-offer-mobile-md.svg',
  },
  backEnd: {
    title: t('services.offer.backEnd.title'),
    description: t('services.offer.backEnd.description'),
    imagePath: 'services-what-we-offer-backend-md.svg',
  },
}
</script>

<template>
  <div class="relative xs:mt-44 sm:mt-24">
    <img src="/services/services-what-we-offer.svg" class="xs:hidden lg:block" alt="" />
    <div class="flex justify-between gap-14 xs:flex-col xs:items-center md:flex-row md:items-start">
      <div class="left-2/4 top-[21%] z-20 flex items-center lg:absolute">
        <WeOfferDetails id="we-offer" class="w-full" :data="info.frontEnd" />
      </div>
      <div class="top-[43%] z-20 xs:flex lg:absolute lg:w-1/2">
        <WeOfferDetails class="md:w-[331px] lg:w-full" :data="info.mobile" />
      </div>
    </div>
    <div class="left-2/4 z-20 flex flex-col lg:absolute lg:top-[95rem] xl:top-[115rem]">
      <WeOfferDetailsBackEnd :data="info.backEnd" />
    </div>
  </div>
</template>
